<template>
  <div>

    <b-form-group>
      <b-form-radio-group
        stacked
        id="radio-group-1"
        v-model="selected"
        :options="radio_options"
        name="packing-group"
        >

        <template slot="first">
          <!-- <b-col> -->
            <b-form-radio class="mb-2" value='none'>None</b-form-radio>
            <b-form-radio class="mt-2" value='solo'>Solo</b-form-radio>

            <b-form-row>
              <b-col cols="4" class="m-0">
                <b-form-radio class="my-2" value='ingroups'>In Groups of:</b-form-radio>
              </b-col>
              <b-col cols="2" class="m-0">
                <b-form-input class="mb-0" type="number" v-if="this.selected == 'ingroups'"/>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="4" class="m-0">
                <b-form-radio class="my-2" value='groupid'>Group ID:</b-form-radio>
              </b-col>
              <b-col cols="2" class="m-0">
                <b-form-input class="mb-0" type="text" v-if="this.selected == 'groupid'"/>
              </b-col>
            </b-form-row>
        </template>
      </b-form-radio-group>
    </b-form-group>

    <b-form-group>
      <b-collapse id="multipackModal" :visible="isMultipack">
        <b-table
          class="packTable"
          hover striped responsive
          :items="multi_attr"
          :fields="columns"
          >

          <template slot="x" slot-scope="row">
            <b-col>
              <b-form-input class="w-60" type="number" :min="0" v-model="multi_attr[row.index].x"/>
              <p>x</p>
            </b-col>
          </template>

          <template slot="y" slot-scope="row">
            <b-col>
              <b-form-input class="w-60" type="number" :min="0" v-model="multi_attr[row.index].y"/>
              <p>x</p>
            </b-col>

          </template>

          <template slot="z" slot-scope="row">
            <b-col>
              <b-form-input class="w-60" type="number" :min="0" v-model="multi_attr[row.index].z"/>
              <p>#</p>
            </b-col>
          </template>

          <template slot="weight" slot-scope="row">
            <b-col>
              <b-form-input class="w-60" type="number" :min="0" v-model="multi_attr[row.index].weight"/>
              <p>$</p>
            </b-col>
          </template>

          <template slot="value" slot-scope="row">
            <b-col>
              <b-form-input class="w-60" type="number" :min="0" v-model="multi_attr[row.index].value"/>
              <p>@</p>
            </b-col>
          </template>

          <template slot="solo" slot-scope="row">
              <b-col>
              <b-form-checkbox
                v-model="multi_attr[row.index].solo"
                value="true"
                class="m-0 p-0 myAdjust"
                text-field="test"
                unchecked_value="false"
                 />
              </b-col>
          </template>

          <template slot="delete" slot-scope="row">
            <b-button variant="danger" @click="deleteRow(row.index)" >
              <i class="fas fa-trash-alt w-60"></i>
            </b-button>
          </template>

          </b-table>
          <b-button block variant="success" @click="addShippingField" >+</b-button>
        </b-collapse>

    </b-form-group>

    <b-form-row class="my-2">
      <b-button-group>
        <b-button variant="primary" @click="submitChange">Save Changes</b-button>
        <!-- <b-button variant="submit" @click="toggleFields">Toggle disabled</b-button> -->
        <b-button variant="danger" @click="reload">Discard unsaved</b-button>
        <b-button variant="warning" @click="resetSpecial">Reset from WA</b-button>
      </b-button-group>
    </b-form-row>

  </div>
</template>


<script>

export default {
  name: 'pack-modal',
  props: {
    special: { type: Array, default: function() {return [] }},
    index: 0,
    loading: false,
  },
  data() {
    return {
      selected: 'none',
      ship_type: 'none',
      test: '',
      status: 'not-solo',
      groups_of: 0,
      multi_show: true,
      multi_attr: [],//[{x: 15, y: 15, z: 15, weight: 20, value: 24, solo: true}],
      radio_options: [
        // {text: 'None', value: 'none'},
        // {text: 'Solo', value: 'solo'},
        // {text: 'In groups:', value: 'ingroups'},
        {text: 'Multipack', value: 'multipack'}
      ],
      columns: {
        x: {
          label: 'X Dimension', thStyle: { width: '10%', }
        },
        y: {
          label: 'Y Dimension', thStyle: { width: '10%', }
        },
        z: {
          label: 'Z Dimension', thStyle: { width: '10%', }
        },
        weight: {
          label: 'Weight', thStyle: { width: '10%', }
        },
        value: {
          label: 'Value', thStyle: { width: '10%', }
        },
        solo: {
          label: 'Solo', thStyle: { width: '5%', }
        },
        delete: {
          label: 'Delete', thStyle: { width: '5%', }
        },
      }
    }
  },
  computed: {
    isMultipack() {
      return this.selected == 'multipack';
    }
  },
  methods: {
    printSelected() {
      console.warn('NotImplementedThing', this.selected);
    },
    submitChange() {
      var ret_special = [];
      ret_special.push(this.selected);
      if (this.selected == 'multipack') {
        ret_special.push(this.multi_attr.map( (row) => {
          return row.x + 'x' + row.y + 'x' + row.z + '#' + row.weight * 16.0 + '$' + row.value + (row.solo ? '@solo' : '');
        }));
      }
      ret_special = ret_special.flat();
      this.$emit('stringaltered', ret_special)
    },
    toggleFields() {
      this.multi_show = !(this.multi_show);
    },
    addShippingField() {
      this.multi_attr.push( {x: 1, y: 1, z: 1, weight: 1, value: 0, solo: true} );
    },
    deleteRow(ix) {
      this.multi_attr.splice(ix, 1);
    },
    reload() {
      if (this.special == '' || this.special == null) {
        this.selected = 'none';
        this.multi_attr = [];
      }
      else {
        this.ship_type = this.special[0];
        this.selected = this.ship_type;
        this.multi_attr = [];
        if (this.ship_type == 'multipack') {
          this.multi_attr = this.special.slice(1).map((x) => {
            var nums = x.split(/[^0-9]+/);
            return {
              x:      nums[0],
              y:      nums[1],
              z:      nums[2],
              weight: nums[3] / 16.0,
              value:  nums[4],
              solo: (x .indexOf('solo') != -1),
            }
          })
        }
      }
    },
    resetSpecial() {
      this.$emit('resetSpecial', this.index);
    },
  },
  watch: {
    selected: function(newValue, oldValue) {
      this.multi_show = (this.selected == 'multipack');
    },
    'special': function(newValue, oldValue) {
      if (this.special != null) {
        this.reload();
      }
    }
  },
  mounted() {
    this.reload();
  },
}


</script>

<style>
  .myAdjust label::before, .myAdjust label::after{
    top: 0px;
    left: 0px;
  }

  .myAdjust label {
    margin-bottom: 0.33rem;
  }

 .packTable table thead tr th{
    text-align: center;
  }

  .packTable table tbody tr td *{
    white-space:nowrap;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/pack-and-ship/PackModal.vue